import { render, staticRenderFns } from "./moveoverdetail.vue?vue&type=template&id=69369b8b&scoped=true&"
import script from "./moveoverdetail.vue?vue&type=script&lang=js&"
export * from "./moveoverdetail.vue?vue&type=script&lang=js&"
import style0 from "./moveoverdetail.vue?vue&type=style&index=0&id=69369b8b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69369b8b",
  null
  
)

export default component.exports